const tag = 'accordion-component'

if (!customElements.get(tag)) {
  customElements.define(
    tag,
    class Accordion extends HTMLElement {
      busy = false;
      isOpen = this.hasAttribute('open');
      duration = Number(this.getAttribute('duration')) || 700;
      name = this.getAttribute('name') || 'accordion';
      keep = this.getAttribute('keep-other') !== null || false;

      trigger = null;
      content = null;
      inner = null;

      constructor() {
        super();
      }

      connectedCallback() {
        this.trigger = this.querySelector('.accordion__trigger');
        this.content = this.querySelector('.accordion__content');
        this.inner = this.content?.querySelector('.accordion__inner') || null;

        if (this.trigger) {
          this.trigger.addEventListener('click', this.toggle);
        }
      }

      open() {
        this.setAttribute('open', '');
        if (this.busy) {
          return;
        }

        this.busy = true;

        if (!this.keep) {
          this.closeAll();
        }

        if (!this.isOpen && this.content) {
          this.content.style.height = this.getHeight();
          this.parentElement.classList.add('has-open-accordion');
          requestAnimationFrame(() => {
            this.classList.add('accordion-open');
            setTimeout(() => {
              if (this.content) {
                this.content.style.height = '';
              }
              this.isOpen = true;
              this.busy = false;
            }, this.duration);
          });
        }
      }

      closeAll() {
        Array.from(this.parentElement?.querySelectorAll(`${Accordion.component}`) || []).forEach((acc) => {
          if (acc !== this) {
            acc.removeAttribute('open');
          }
        });
      }

      close() {
        this.removeAttribute('open');
        this.busy = true;
        if (this.content) {
          this.content.style.height = this.getHeight();
          this.parentElement.classList.remove('has-open-accordion');
          requestAnimationFrame(() => {
            this.classList.remove('accordion-open');
            setTimeout(() => {
              if (this.content) {
                this.content.style.height = '';
              }
              this.isOpen = false;
              this.busy = false;
            }, this.duration);
          });
        }
      }

      openByName(name) {
        if (this.name === name) this.open();
      }

      toggle = () => {
        if (this.busy) {
          return;
        }

        if (this.hasAttribute('open')) {
          this.close()
        } else {
          this.open();
        }
      };

      getHeight() {
        return `${this.inner?.getBoundingClientRect().height}px` || '0px';
      }
    }
  )
}
